/**
 *
 * @param value
 * @returns
 */
export const isEmpty = (value: string) => {
  return value == null || value == undefined || value.length == 0;
};

export const getMoneyFormat = (price: number) => {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const getMoneyFormatByString = (price: string) => {
  let value = isEmpty(price) ? "0" : price;
  value = parseInt(value).toString();
  const number = extractNumber(value);
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

/**
 * 숫자만 응답
 */
export const extractOnlyNumber = (str: string) => {
  return str.replace(/[^0-9.]/g, "");
};
/**
 * 숫자와 부호만 응답
 * @param input 데이터
 * @returns
 */
export const extractNumber = (input: string) => {
  // 정규식을 사용하여 숫자와 부호만을 추출합니다.
  const numberPattern = /[+-]?\d+(\.\d+)?/g;
  const extracted = input.match(numberPattern);

  // 추출된 숫자와 부호를 조합하여 문자열로 반환합니다.
  return extracted ? extracted.join("") : "";
};

export const getPhoneFormat = (phoneNumber: string) => {
  if (isEmpty(phoneNumber)) {
    return "";
  }
  const digits = phoneNumber.replace(/\D/g, "");
  const match = digits.match(/^(\d{3})(\d{4})(\d{4})$/);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : phoneNumber;
};

export const extractPlusNumbers = (data: string): string => {
  console.log("data : ", data);
  const numbers = data.match(/-?\d+(\.\d+)?/g) || [];

  // 각 숫자를 소수 둘째 자리까지 반올림하여 변환
  const roundedNumbers = numbers.map((number) => {
    // parseFloat를 사용하여 문자열을 숫자로 변환하고, 소수점 이하 둘째 자리까지 반올림
    const roundedNumber = parseFloat(number).toFixed(2);
    // "+" 기호가 없는 경우 "+" 기호를 붙여줌
    return roundedNumber.startsWith("-") ? roundedNumber : "+" + roundedNumber;
  });

  console.log("-> ", roundedNumbers);
  return roundedNumbers.toString();
};

export const isValidEmail = (email: string): boolean => {
  // 이메일 정규 표현식
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
